import React from 'react';
import { Box, Skeleton } from '@mui/material';
import { CONTROL, PRES } from '../chrome';

const SkeletonCard: React.FC = () => (
  <Box sx={{
    border: `1px solid ${PRES.borderSubtle}`,
    borderRadius: `${CONTROL.radiusCard}px`,
    overflow: 'hidden',
    bgcolor: PRES.surface,
  }}>
    <Skeleton variant="rectangular" sx={{ width: '100%', paddingTop: '56.25%', transform: 'none' }} />
    <Box sx={{ p: 1.5 }}>
      <Skeleton width="70%" height={18} />
      <Skeleton width="46%" height={14} sx={{ mt: 1 }} />
    </Box>
  </Box>
);

export default SkeletonCard;
